import script from "./ReservationView.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationView.vue?vue&type=script&setup=true&lang=js"

import "./ReservationView.vue?vue&type=style&index=0&id=730c7edc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-730c7edc"]])

export default __exports__